// Hover feedback for any face-up tile on the table: a small floating tooltip
// naming the tile (reuses `tileName` from the Coach panel's copy) and a
// pointer cursor when the hovered tile can actually be tapped right now (the
// local discard turn). Driven by `scenes/SceneCallbacks.findHoveredTile`,
// which resolves what's under the pointer across the whole table.

import { el } from '@bn-games/ui-shell';
import type { HoveredTile } from '../scenes/SceneCallbacks.js';
import { tileName } from './tileName.js';

const OFFSET_X_PX = 14;
const OFFSET_Y_PX = -12;

const TOOLTIP_STYLE = [
  'position:fixed',
  'padding:0.35rem 0.6rem',
  'border-radius:0.4rem',
  'font-size:0.85rem',
  'font-weight:600',
  'pointer-events:none',
  'white-space:nowrap',
  'background:rgba(6,32,24,0.92)',
  'color:#f4e6c0',
  'box-shadow:0 0.25rem 0.75rem rgba(0,0,0,0.4)',
  'z-index:25',
  'font-family:system-ui,-apple-system,sans-serif',
].join(';');

export class TileHoverCursor {
  private readonly tooltip: HTMLElement;

  constructor(private readonly canvas: HTMLCanvasElement) {
    this.tooltip = el('div', { attrs: { style: `${TOOLTIP_STYLE};display:none` } });
    document.body.appendChild(this.tooltip);
  }

  /** `point` is null when the pointer has left the canvas or nothing is hovered. */
  update(hovered: HoveredTile | null, point: { x: number; y: number } | null): void {
    if (hovered === null || point === null) {
      this.canvas.style.cursor = 'default';
      this.tooltip.style.display = 'none';
      return;
    }
    this.canvas.style.cursor = hovered.usable ? 'pointer' : 'default';
    this.tooltip.textContent = tileName(hovered.tile);
    this.tooltip.style.left = `${point.x + OFFSET_X_PX}px`;
    this.tooltip.style.top = `${point.y + OFFSET_Y_PX}px`;
    this.tooltip.style.display = 'block';
  }

  dispose(): void {
    this.canvas.style.cursor = 'default';
    this.tooltip.remove();
  }
}
